import { render, staticRenderFns } from "./StockInfoSidebar.vue?vue&type=template&id=5824fe66&scoped=true"
import script from "./StockInfoSidebar.vue?vue&type=script&lang=js"
export * from "./StockInfoSidebar.vue?vue&type=script&lang=js"
import style0 from "./StockInfoSidebar.vue?vue&type=style&index=0&id=5824fe66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5824fe66",
  null
  
)

export default component.exports